// extracted by mini-css-extract-plugin
module.exports = {"button":"clinical-portal-3__google-form-dialog__button","dialog":"clinical-portal-3__google-form-dialog__dialog","closeButton":"clinical-portal-3__google-form-dialog__closeButton"};